import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import Button from "@material-ui/core/Button";
import DialogExportar from "../components/DialogExportar";
import SnackbarAlert from "../components/SnackbarAlert";
import TablaCantidadPorCodigoValidado from "../components/TablaCantidadPorCodigoValidado";

class CantidadPorCodigoValidado extends React.Component {
    constructor(props) {
        super(props);
        this.state ={
            value: 'diferencias',
            showTabla: true,
            open: false,
            openSnack: false,
            severity: "",
            message: "",
            reporte: "",
            params: "",
            sin_datos:true,
        }
    }

    handleChange = (event) => {
        this.setState({value: event.target.value, showTabla: !this.state.showTabla});
        setTimeout(() => {
            // After X seconds set the show value to false
            this.setState({showTabla:!this.state.showTabla})
        }, 30)
    }

    handleClose = () =>{
        this.setState({open:false})
    }

    refrescar =(estado,severity) =>{
        this.setState({ open: false, openSnack: false})
        if(severity){
            this.setState({openSnack:true, message: estado, severity: severity})
        }
    }

    componentDidMount(){
    }

    enviarDatosReportes =(e)=>{
        let params = ""
        let reporte = 'cantidad_por_codigo_validado_' + this.state.value
        this.setState({open: true, reporte: reporte, params: params,openSnack:false})
    }

    render() {
        return (
            <div>
                <Grid container spacing={2} direction={"row"} justifyContent={"flex-start"} alignItems="center">
                    <Grid item xs={12}>
                        <Typography variant="h4">Cantidad Por Código Validado</Typography>
                    </Grid>
                </Grid>
                <Grid  container spacing={2} direction={"row"} justifyContent={"flex-start"} alignItems="center">
                    <Grid item>
                        <RadioGroup style={{ display: 'inline-block'}} aria-label="gender" name="value" value={this.state.value} onChange={this.handleChange}>
                            <FormControlLabel value="diferencias" control={<Radio/>} label="Con diferencias" />
                            <FormControlLabel value="todos" control={<Radio/>} label="Todos" />
                        </RadioGroup>
                    </Grid>
                    <Grid item>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.enviarDatosReportes}
                        >Exportar</Button>
                    </Grid>
                </Grid>
                <br/>
                { this.state.open && <DialogExportar reporte={this.state.reporte} origen={'otro'} params={this.state.params} refrescar={this.refrescar} handleClose={this.handleClose} />}
                {this.state.openSnack? <SnackbarAlert  severity={this.state.severity} message={this.state.message}/> : null}
                {this.state.showTabla && <TablaCantidadPorCodigoValidado refrescar={this.refrescar} tipo={this.state.value}/>}
            </div>
        )
    }
}

export default CantidadPorCodigoValidado;